export default "__VITE_ASSET__BdL6I7lR__"